import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, Link, Icon } from '@tvg/fuse-design';
import IconLocalOffer from '@tvg/fuse-icons/lib/LocalOffer';
import { renderContentWithParams, renderContent } from 'utilities/content/content-utilities';
import { getOfferEndDate } from 'utilities/date/date';

const Container = styled.div`
  display: flex;
  margin-bottom: var(--spacing-space24);
  padding-bottom: var(--spacing-space16);
`;

const IconContainer = styled.div`
  flex: 0 0 32px;
`;

const OfferTitle = styled(TypographyElement)`
  color: var(--color-base-black);
`;

const TextContainer = styled.div`
  flex: 1;
  margin-left: var(--spacing-space12);

  b {
    color: var(--color-base-black);
  }
`;

const Apr = styled(TypographyElement)`
  margin: var(--spacing-paragraph-margin-bottom-m1) 0 0 0;
  font-weight: bold;
  color: var(--color-base-black);

  span {
    white-space: nowrap; // % and APR aren't allowed to appear on seperate lines
  }
`;

interface Props {
  apr: string;
  voucherCode: string;
  endDate: string;
  offerTitle: string;
  termLength: number;
  onClickCallback: () => void;
  nonCreditAccountUser: boolean;
}

function CreditToAccount(props: Props) {
  const { apr, voucherCode, endDate, offerTitle, termLength, onClickCallback, nonCreditAccountUser } = props;

  return (
    <Container data-testid="credit-to-account-container">
      <IconContainer>
        <Icon icon={<IconLocalOffer />} width="32px" height="32px" dataTestId="credit-to-account-icon" />
      </IconContainer>

      <TextContainer>
        <OfferTitle tag="p" type="paragraph" size="1" data-testid="credit-to-account-info">
          <strong>{offerTitle}</strong>
        </OfferTitle>
        <TypographyElement
          dangerouslySetInnerHTML={{
            __html: renderContentWithParams({
              id: 'verypay.CTA.card.description1',
              params: [voucherCode, termLength.toString()],
            }),
          }}
          tag="p"
          type="paragraph"
          size="m1"
          data-testid="credit-to-account-text-1"
        />
        <TypographyElement tag="p" type="paragraph" size="m1" data-testid="credit-to-account-text-2">
          {renderContent('verypay.CTA.card.description2')}
        </TypographyElement>
        <TypographyElement
          dangerouslySetInnerHTML={{
            __html: renderContent('verypay.CTA.card.description3'),
          }}
          tag="p"
          type="paragraph"
          size="m1"
          data-testid="credit-to-account-text-3"
        />
        <TypographyElement tag="p" type="paragraph" size="m2" data-testid="credit-to-account-date">
          {renderContentWithParams({
            id: 'verypay.CTA.card.date',
            params: [getOfferEndDate(endDate)],
          })}
        </TypographyElement>
        <Link href="#" onClick={onClickCallback} data-testid="credit-to-account-link" size="medium">
          {renderContent('verypay.CTA.card.link')}
        </Link>

        {apr && nonCreditAccountUser && (
          <Apr
            size="1"
            type="paragraph"
            tag="p"
            dangerouslySetInnerHTML={{
              __html: renderContentWithParams({
                id: 'verypay.card.apr',
                params: [apr],
              }),
            }}
            data-testid="verypay_card_apr"
          />
        )}
      </TextContainer>
    </Container>
  );
}

export default CreditToAccount;
